import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import Grid                    from '@material-ui/core/Grid'
import MenuItem                from '@material-ui/core/MenuItem/MenuItem'
import { InjectedFormikProps } from 'formik'

import { Experience }                from '../../../api'
import { sectors }                   from '../../../project-utils/hardcoded'
import { AbstractedFormikTextField } from '../../atoms'
import { InlineDatePicker }          from '../../atoms/DatePicker'

export default (props: InjectedFormikProps<{}, Experience>) => (
  <Grid container spacing={8}>
    <Grid item xs={12}>
      <AbstractedFormikTextField
        autoFocus
        fullWidth
        margin={'dense'}
        identifier={'position'}
        {...props}
      />
    </Grid>
    <Grid item xs={12}>
      <AbstractedFormikTextField
        fullWidth
        margin={'dense'}
        identifier={'company'}
        {...props}
      />
    </Grid>
    <Grid item xs={12} md={6}>
      <InlineDatePicker
        fullWidth
        label={'start'}
        name={'start'}
        onChange={props.handleChange}
        value={props.values.start}
        format={'DD/MM/YYYY'}
      />
    </Grid>
    <Grid item xs={12} md={6}>
      <InlineDatePicker
        fullWidth
        label={'end'}
        name={'end'}
        onChange={props.handleChange}
        value={props.values.end}
        format={'DD/MM/YYYY'}
      />
    </Grid>
    <Grid item xs={12}>
      <AbstractedFormikTextField
        fullWidth
        identifier={'sector'}
        select
        {...props}
      >
        {sectors.map(sector => (
          <MenuItem key={sector} value={sector}>
            <FormattedMessage id={`sectors.${sector}`} />
          </MenuItem>
        ))}
      </AbstractedFormikTextField>
    </Grid>
  </Grid>
)



// WEBPACK FOOTER //
// ./src/components/forms/chunks/SingleExperienceChunk.tsx